export default __webpack_public_path__ + "static/media/family_star.c328c9b7.svg";